import classNames from 'classnames';
import { FC, memo } from 'react';

interface iSelectProps {
  value?: string;
  onChange: (val: string) => void;
  options: { label: string; value: string }[];
  error?: string;
}

const Select: FC<iSelectProps> = memo(({ options, value, onChange, error }) => {
  const _handleChange = ({ target: { value } }: any) => onChange(value);

  return (
    <div className={classNames('select-wrapper', error && 'error')}>
      <select value={value} onChange={_handleChange}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <img src='/images/chevron-down.svg' alt='' />
    </div>
  );
});

export default Select;
